import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';
import api from '../../services/api';
import { FaEye, FaRegEyeSlash } from 'react-icons/fa';
import { API_BASE_URL, API_URL, DEFAULT_PER_PAGE, ELIGIBLE_FOR_COMMISSION_OPTIONS } from '../../utilities/constants';
import PaginatedDropdown, { mapOptions } from '../../components/ui/PaginatedDropDown';
import { handleApiCall, sleep } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const EditUser = () => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [departmentId, setdepartmentId] = useState(null);
    const [subdepartmentId, setSubDepartmentId] = useState(null);
    const [modules, setModules] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const { id } = useParams();
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    const [initialValues, setInitialValues] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        isEligibleForCommission: "",
        managerId: "",
        departmentId: null,
        subdepartmentId: [],
        modules: [],
    });
    const validationSchema = Yup.object().shape({
        // firstName: Yup.string().required('First Name is required'),
        // lastName: Yup.string().required('Last Name is required'),
        // email: Yup.string().email().required('Email is required'),
        // password: Yup.string().required('Password is required'),
        // isEligibleForCommission: Yup.string().required('Commission is required'),

    });

    const fetchAgentByID = async () => {
        setLoading(true);
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/agent/${id}`, {
                method: "GET"
            });
            if (response.responseStatus === true) {
                setData(response.data);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log("Error:", e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAgentByID(id);
    }, [id])

    useEffect(() => {
        setInitialValues({
            firstName: data?.firstName,
            lastName: data?.lastName,
            phoneNumber: data?.phoneNumber,
            email: data?.email,
            isEligibleForCommission: data?.isEligibleForCommission === true ? 1 : 2,
            managerId: data?.manager
                ? {
                    value: data?.manager?.agentId,
                    label: data?.manager?.firstName + " " + data?.manager?.lastName
                }
                : null,
            departmentId: data?.agentDepartments?.length
                ? {
                    value: data.agentDepartments[0]?.subDepartment?.department?.departmentId,
                    label: data.agentDepartments[0]?.subDepartment?.department?.departmentName
                }
                : null,

            // departmentId: data?.agentDepartments ?
            //     data?.agentDepartments.map((item) => ({
            //         value: item?.subDepartment?.department?.departmentId,
            //         label: item?.subDepartment?.department?.departmentName
            //     }))
            //     : null,
            subdepartmentId: data?.agentDepartments ?
                data?.agentDepartments.map((item) => ({
                    val: item?.subDepartment?.subDepartmentId,
                    name: item?.subDepartment?.subDepartmentName
                })) : [],
            modules: data?.agentModulesAccess
                .map(moduleItem => ({
                    val: moduleItem.module?.moduleId,
                    name: moduleItem.module?.moduleName,
                    // isViewAccess: moduleItem?.listAccess === true ? 1 : 0,
                    isAddAccess: moduleItem?.addAccess === true ? 1 : 0,
                    isUpdateAccess: moduleItem?.editAccess === true ? 1 : 0,
                    isDeleteAccess: moduleItem?.deleteAccess === true ? 1 : 0,
                    isViewAccess: moduleItem?.viewAccess === true ? 1 : 0,
                })) || [],

        })
    }, [data])

    const handleEditUser = async (value) => {
        setLoading(true);
        try {
            const payload = {
                firstName: value.firstName,
                lastName: value.lastName,
                phoneNumberType: value.phoneNumberType,
                phoneNumber: value.phoneNumber,
                isEligibleForCommission: Number(value.isEligibleForCommission),
                managerId: value?.managerId?.value || null,
                agentDepartments: [
                    {
                        departmentId: value?.departmentId.value || null,
                        subDepartmentId: value?.subdepartmentId.find(item => item.val)?.val || null,
                        agentModules: Array.isArray(value.modules)
                            ? value.modules.map((module) => ({
                                moduleId: module.val,
                                addAccess: module.isAddAccess ? 1 : 0,
                                editAccess: module.isUpdateAccess ? 1 : 0,
                                viewAccess: module.isViewAccess ? 1 : 0,
                                listAccess: module.isViewAccess ? 1 : 0,
                                deleteAccess: module.isDeleteAccess ? 1 : 0,
                            }))
                            : [],
                    },
                ],
            };
            console.log('payload', payload)

            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/agent/${id}`, {
                method: "PUT",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully updated a Agent, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully updated a Agent!",
                    status: true,
                    archive: false,
                });
                navigate(`/agents?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while updating a Agent. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while updating a Agent.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };


    const labelManagerFunc = (o) => `${o.firstName}  ${o.lastName}`;
    const labelSubDepartmentFunc = (o) => `${o.subDepartmentName}`;
    const labelDepartmentFunc = (o) => `${o.departmentName}`;
    const labelModuleFunc = (o) => `${o.moduleName}`;


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleEditUser}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">First Name</label>
                            <Field
                                name="firstName"
                                type="text"
                                placeholder="Enter country"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.firstName && touched.firstName && (
                                <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Last Name</label>
                            <Field
                                name="lastName"
                                type="text"
                                placeholder="Enter lastName"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.transferType && touched.transferType
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.lastName && touched.lastName && (
                                <p className="text-xs text-red-500 mt-1">{errors.lastName}</p>
                            )}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">Email</label>
                            <Field
                                name='email'
                                type='email'
                                placeholder='Eg: a@mail.com'
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.email && touched.email && (
                                <p className="text-xs text-red-500 mt-1">{errors.email}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Password</label>

                            <div className="relative w-full">
                                <Field
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Eg: abc*****"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring pr-10
                                        ${errors.password && touched.password
                                            ? "border-red-500 focus:ring-red-300"
                                            : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                        }`}
                                />

                                <span
                                    onClick={togglePasswordVisibility}
                                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 cursor-pointer text-lg"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <FaRegEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            {errors.password && touched.password && (
                                <p className="text-xs text-red-500 mt-1">{errors.password}</p>
                            )}
                        </div>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">Phone Number</label>
                            <Field
                                name='phoneNumber'
                                type='text'
                                placeholder='Eg: 05657688'
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.phoneNumber && touched.phoneNumber && (
                                <p className="text-xs text-red-500 mt-1">{errors.phoneNumber}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Eligible For Commission</label>
                            <Field
                                as='select'
                                name='isEligibleForCommission'
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.transferType && touched.transferType
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            >
                                <option value=''>Select</option>
                                {ELIGIBLE_FOR_COMMISSION_OPTIONS.map((d, i) => (
                                    <option value={d.value} key={i}>
                                        {d.label}
                                    </option>
                                ))}
                            </Field>
                            {errors.isEligibleForCommission && touched.isEligibleForCommission && (
                                <p className="text-xs text-red-500 mt-1">{errors.isEligibleForCommission}</p>
                            )}
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">Department</label>
                            <PaginatedDropdown
                                searchkey="search"
                                datakey="records"
                                url={`${API_BASE_URL}/api/1.0.0/department?`}
                                mapOptions={(records) =>
                                    mapOptions(
                                        records,
                                        "departmentId",
                                        labelDepartmentFunc
                                    )
                                }
                                error={errors.departmentId && touched.departmentId ? errors.departmentId : ""}
                                selectedValue={values?.departmentId}
                                placeHolder='Search'
                                onChange={(v) => {
                                    setFieldValue(
                                        "departmentId",
                                        v
                                    );
                                }}

                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Manager</label>
                            <PaginatedDropdown
                                searchkey="search"
                                datakey="records"
                                // url = {`${API_URL}/api/1.0.0/agent/managers?departmentId=${values?.departmentId?.value}&sortOrder=ASC&pageSize=10&pageNo=0`}
                                url={`${API_BASE_URL}/api/1.0.0/agent/managers?departmentId=${values?.departmentId?.value}&`}
                                mapOptions={(records) =>
                                    mapOptions(
                                        records,
                                        "agentId",
                                        labelManagerFunc
                                    )
                                }
                                error={errors.managerId && touched.managerId ? errors.managerId : ""}
                                selectedValue={values?.managerId}
                                placeHolder='Search'
                                onChange={(v) => {
                                    setFieldValue(
                                        "managerId",
                                        v
                                    );
                                }}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">SUb Department</label>
                        <PaginatedDropdown
                            searchkey="search"
                            datakey="records"
                            url={`${API_BASE_URL}/api/1.0.0/sub-department?`}
                            mapOptions={(records) =>
                                mapOptions(
                                    records,
                                    "subDepartmentId",
                                    labelSubDepartmentFunc
                                )
                            }
                            selectedValue={subdepartmentId}
                            placeHolder='Search'
                            onChange={async (v) => {
                                if (v) {
                                    setSubDepartmentId(v);
                                    const p =
                                        values?.subdepartmentId;
                                    const n = {
                                        val: v.value,
                                        name: v.label,
                                    };
                                    if (
                                        !p.some(
                                            (item) =>
                                                item.val ===
                                                v.value
                                        )
                                    ) {
                                        setFieldValue(
                                            "subdepartmentId",
                                            [
                                                ...values?.subdepartmentId,
                                                n,
                                            ]
                                        );
                                    }
                                }
                                await sleep();
                                setSubDepartmentId(null);
                            }}
                        />

                        {values?.subdepartmentId.length > 0 && (
                            <ul className="w-full py-2">
                                {values?.subdepartmentId.map((p, j) => (
                                    <li
                                        key={j}
                                        data-tooltip="Click to delete the module."
                                        onClick={() => {
                                            const filtered = values?.subdepartmentId.filter(
                                                (obj) => obj.val !== p.val
                                            );
                                            setFieldValue("subdepartmentId", filtered);
                                        }}
                                        className="
                                            inline-block 
                                            mr-1 mb-1 
                                            px-3 py-2 
                                            text-left text-sm 
                                            rounded 
                                            leading-8 
                                            cursor-pointer 
                                            bg-gray-100 text-brand-600 
                                            hover:bg-brand-100 
                                            transition
                                          "
                                         >
                                        <div className="flex items-center justify-start gap-1">
                                            <p className="truncate w-[108px] text-xs">{p.name}</p>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-4 w-4"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="#283f54"
                                                    d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.151,17.943-4.143-4.1L7.891,18,6.058,16.167l4.1-4.157L6,7.891,7.833,6.058l4.155,4.1L16.094,6l1.849,1.849-4.1,4.141L18,16.094Z"
                                                />
                                            </svg>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}

                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Module</label>
                        <PaginatedDropdown
                            searchkey="search"
                            datakey="records"
                            url={`${API_BASE_URL}/api/1.0.0/modules?`}
                            mapOptions={(records) =>
                                mapOptions(records, "moduleId", labelModuleFunc)
                            }
                            selectedValue={modules}
                            placeHolder="Search"
                            onChange={async (v) => {
                                if (v) {
                                    setModules(v);
                                    const p = values.modules;
                                    const n = {
                                        val: v.value,
                                        name: v.label,
                                        isAddAccess: false,
                                        isDeleteAccess: false,
                                        isviewAccess: false,
                                        isUpdateAccess: false,
                                    };
                                    if (!p.some((item) => item.val === v.value)) {
                                        setFieldValue("modules", [...values.modules, n]);
                                    }
                                }
                                await sleep();
                                setModules(null);
                            }}
                        />
                        {values?.modules.length > 0 && (
                            <FieldArray name="modules">
                                {({ remove }) => (
                                    <div className="overflow-x-auto mt-4">
                                        <table className="min-w-full border border-gray-200 rounded-lg shadow-sm">
                                            <thead>
                                                <tr className="bg-gray-100 text-gray-700 text-sm font-semibold">
                                                    <th className="px-4 py-2 text-left">Module</th>
                                                    <th className="px-4 py-2 text-center">List</th>
                                                    <th className="px-4 py-2 text-center">Add</th>
                                                    <th className="px-4 py-2 text-center">Update</th>
                                                    <th className="px-4 py-2 text-center">Delete</th>
                                                    <th className="px-4 py-2 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {values.modules.map((val, index) => (
                                                    <tr key={index} className="hover:bg-gray-50">
                                                        <td className="px-4 py-2 text-gray-800 font-medium">{val.name}</td>
                                                        <td className="px-4 py-2 text-center">
                                                            <Field
                                                                name={`modules.${index}.isviewAccess`}
                                                                type="checkbox"
                                                                className="h-4 w-4 text-brand-600 border-gray-300 rounded"
                                                            />
                                                        </td>
                                                        <td className="px-4 py-2 text-center">
                                                            <Field
                                                                name={`modules.${index}.isAddAccess`}
                                                                type="checkbox"
                                                                className="h-4 w-4 text-brand-600 border-gray-300 rounded"
                                                            />
                                                        </td>
                                                        <td className="px-4 py-2 text-center">
                                                            <Field
                                                                name={`modules.${index}.isUpdateAccess`}
                                                                type="checkbox"
                                                                className="h-4 w-4 text-brand-600 border-gray-300 rounded"
                                                            />
                                                        </td>
                                                        <td className="px-4 py-2 text-center">
                                                            <Field
                                                                name={`modules.${index}.isDeleteAccess`}
                                                                type="checkbox"
                                                                className="h-4 w-4 text-brand-600 border-gray-300 rounded"
                                                            />
                                                        </td>
                                                        <td className="px-4 py-2 text-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => remove(index)}
                                                                className="px-3 py-1 text-sm font-medium text-red-600 border border-red-500 rounded hover:bg-red-50"
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </FieldArray>
                        )}

                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/user'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};

export default EditUser;


